import { AbstractControl } from '@angular/forms';

export class CpfValidator {

  /**
   *
   *
   * @param AbstractControl control
   * @return object ou null
   */
  static validate(control: AbstractControl): { [key: string]: boolean } | null {
    if (this.cpfValido(control.value)) {
      return null;
    }
    return { 'invalid_cpf': true };
  }

  static cpfValido(cpf: any): boolean {

    if (cpf === null || cpf === undefined || cpf.length === 0) {
      return true;
    }

    cpf = !cpf || cpf.replace(/\D/g, '');
    const cpfsInvsRegex = /1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11}|0{11}/;

    if (!cpf || cpf.length !== 11 || cpfsInvsRegex.test(cpf)) {
      return false;
    }

    let x = cpf.length - 1;
    let digitosTemp = 0;
    let e = 0;
    let h = '';

    for (let i = 0; i <= cpf.length - 3; i++) {
      digitosTemp = cpf.substring(i, i + 1);
      e = e + (digitosTemp * x);
      x -= 1;
      h = h + digitosTemp;
    }

    let numbers = 11 - (e % 11);
    if (numbers === 10 || numbers === 11) {
      numbers = 0;
    }

    const cpfSemDigVer = cpf.substring(0, cpf.length - 2) + numbers;
    x = 11;
    e = 0;
    for (let j = 0; j <= (cpf.length - 2); j++) {
      e += (cpfSemDigVer.substring(j, j + 1) * x);
      x -= 1;
    }

    let digVerification = 11 - (e % 11);
    if (digVerification === 10 || digVerification === 11) {
      digVerification = 0;
    }

    return ((numbers + '' + digVerification) === cpf.substring(cpf.length, cpf.length - 2));
  }
}
